
  import Vue from 'vue';
  import * as firebase from 'firebase/app';
  import 'firebase/auth';
  import Component from 'vue-class-component';
  import {Emit, PropSync, Ref} from 'vue-property-decorator';
  import {HttpError} from '@/models/http.error';
  import {SignInCredentials} from '@/models/user.model';
  import {validators} from '@/utils/validations';
  import {AuthApi} from '@/api/auth.api';
  import {take} from 'rxjs/operators';
  import {authModule, authState} from '@/utils/store-acessor';

  const getProvider = (linkedProviderId: string) => {
    switch (linkedProviderId) {
      case firebase.auth.GoogleAuthProvider.PROVIDER_ID:
        return new firebase.auth.GoogleAuthProvider();
      case firebase.auth.FacebookAuthProvider.PROVIDER_ID:
        return new firebase.auth.FacebookAuthProvider();
      default:
        throw new Error('Sign In provider not supported!');
    }
  };

  @Component({})
  export default class SignInDialog extends Vue {
    readonly rules = validators;
    credentials = new SignInCredentials('', '');
    valid = false;
    showLoading = false;
    // @ts-ignore
    @Ref() signForm: VForm;
    @authModule.Mutation('authenticationSuccess') authSuccess: any;
    @authModule.Mutation('authenticationFailed') authFailed: any;
    @authModule.Getter('authenticationErrors') errors!: HttpError;
    @PropSync('open', {default: false, required: true}) dialogOpen!: boolean;

    async mounted() {
      // this.authEvents();
      await this.firebaseCallback();
    }

    private async firebaseCallback() {
      // Capture sign-in from redirect
      try {
        const result = await firebase.auth().getRedirectResult();
        if (!result.credential) {
          return; // No authenticate action.
        }

        // @ts-ignore
        const {accessToken, providerId} = result.credential;
        const ikoneProvider = providerId.replace('.com', '');
        this.sendAuthToServer(
                accessToken,
                ikoneProvider as 'facebook' | 'linkedin' | 'google'
        );
      } catch (error) {
        const {code, email, credential} = error;

        const prevUser = firebase.auth().currentUser;
        firebase.auth().signInWithCredential(credential).then(function(user) {
          const currentUser = user;
          // @ts-ignore
          return user.delete().then(function() {
            // @ts-ignore
            return prevUser.linkWithCredential(credential);
          }).then(function() {
            return firebase.auth().signInWithCredential(credential);
          });
        }).catch(function(error) {
          // console.log('Sign In Error', error);
        });

        if (email && credential && code === 'auth/account-exists-with-different-credential') {
          const [linkedProviderId] = await firebase.auth().fetchSignInMethodsForEmail(email);

          const linkedProvider = getProvider(linkedProviderId);
          linkedProvider.setCustomParameters({login_hint: email});

          const result = await firebase.auth().signInWithRedirect(linkedProvider);
          console.log('result =>', result);
          // @ts-ignore
          result.user.linkWithCredential(credential);
        }

        this.authFailed(error);
        throw new Error(error);
      }
    }

    onForgotPassword() {
      this.$router.push({name: 'forgotPassword'});
    }

    async onSignIn() {
      if (this.signForm.validate()) {
        this.showLoading = true;
        try {
          await authState.makeLogin(this.credentials);
          this.onSuccess();
        } catch (e) {
          console.log(e);
          this.showLoading = false;
          if (e?.response?.data) {
            this.authFailed(e.response.data);
          }
        }
      }
    }

    onSignUp() {
      this.$router.push({name: 'register'});
    }

    onSignInWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    }

    onSignInWithFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    }

    private sendAuthToServer(token: string, type: 'facebook' | 'linkedin' | 'google') {
      new AuthApi()
      .signInWithSocial(token, type)
      .pipe(take(1))
      .subscribe(
        res => {
          this.authSuccess(res);
          this.showLoading = false;
        },
        error => {
          this.$router.push({ name: 'acceptTermsAndConditions', params:{token, type}});
        }
      );
    }

    @Emit()
    onSuccess() {
      this.showLoading = false;
      this.dialogOpen = false;
      return;
    }

    @Emit()
    onCancel() {
      this.dialogOpen = false;
      return;
    }
  }
